import { Link as RouterLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Icon } from '@iconify/react'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import CardContent from '@mui/material/CardContent'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { SCHOOL_DEPARTMENTS } from '@jupi/shared'
import { RemoteContent, Title } from '@jupi/ui'
import { useCourses } from '../../api/school'

// The courses the member instructs or runs, by department, plus any they
// are enrolled on as a student.
export default function CoursesPage() {
  const { t } = useTranslation()
  const { data: courses = [], isLoading, error } = useCourses()

  return (
    <Box>
      <Title label={t('school.courses')} />
      <RemoteContent isLoading={isLoading} error={error}>
        {courses.length === 0 && !isLoading ? (
          <Typography color="text.secondary">{t('school.noCourses')}</Typography>
        ) : null}
        <Stack spacing={3}>
          {SCHOOL_DEPARTMENTS.map((department) => {
            const own = courses.filter((c) => c.department === department)
            if (own.length === 0) return null
            return (
              <Box key={department}>
                <Typography variant="overline" color="text.secondary">
                  {t(`school.department_${department}`)}
                </Typography>
                <Box sx={{ display: 'grid', gap: 1.5, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' } }}>
                  {own.map((course) => (
                    <Card key={course.courseCode} variant="outlined">
                      <CardActionArea component={RouterLink} to={`/school/courses/${course.courseCode}`}>
                        <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                          <Icon icon="mdi:book-open-page-variant-outline" width={28} />
                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography sx={{ fontWeight: 600 }}>{course.name}</Typography>
                            <Typography variant="caption" color="text.secondary">
                              {course.courseCode}
                            </Typography>
                            {course.completeWithin ? (
                              <Typography variant="caption" color="text.secondary" component="div">
                                {t('school.completeWithin', {
                                  duration: t(`school.completeWithin_${course.completeWithin.unit}`, {
                                    count: course.completeWithin.value,
                                  }),
                                })}
                              </Typography>
                            ) : null}
                          </Box>
                          <Chip size="small" label={department.toUpperCase()} />
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  ))}
                </Box>
              </Box>
            )
          })}
        </Stack>
      </RemoteContent>
    </Box>
  )
}
